import React, { useEffect } from 'react';
import * as jnb from 'react-bootstrap';
import * as Yup from "yup";
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import { useState } from 'react';
import { AADHAR_VALIDATION, ERROR_MSG, handleKeyPressNumeric, MOBILE_VALIDATION, public_url } from '../CommonUtils/Validations/RegularExpAndVar';
import PublicHeader from '../Header/PublicHeader';
import allowNumbersOnly from '../CommonUtils/Validations/CommonValidations';
import { CommomLoginAunthenticatePost } from '../CommonUtils/CommonAxios/CommonAxios';
import { config } from '../CommonUtils/CommonUrl/CommonUrls';
import Sweetalert from '../CommonUtils/CommonPopupAndAlerts/SweetAlerts';
import { useNavigate } from 'react-router-dom';

export default function NewReg() {
    const [showData, setData] = useState(false);
    const [minutes, setMinutes] = useState(1);
    const [seconds, setSeconds] = useState(30);
     const aadhaarRegex = /^[2-9][0-9]{11}$/;
     const phoneRegex=/^[6-9]{1}[0-9]{9}$/;

    const userValidations = Yup.object().shape({
        aadhaar: Yup.string().required(ERROR_MSG).matches(AADHAR_VALIDATION, "Invalid aadhar Number"),
         citizen: Yup.string().required(ERROR_MSG),
        phoneno: Yup.string().required(ERROR_MSG).matches(MOBILE_VALIDATION, "Invalid Phone Number"),
        otp: Yup.string().required(ERROR_MSG),
        pwd: Yup.string().required(ERROR_MSG).matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
            "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
        ),
        repwd: Yup.string().oneOf([Yup.ref("pwd"), null], "Passwords must match").required(ERROR_MSG),

    })
    const formIk = useFormik({
        initialValues: {
            aadhaar: '',
            applicantName: '',
            fatherName: '',
            phoneno: '',
            otp: '',
            pwd: '',
            repwd: "",
            citizen: '',
            dob:"",
            gender:"",
            distName:"",
            mandalName:"",
            villageName:"",
            houseNo:"",
            pincode:"",
            address:""
        },
        validationSchema: userValidations,

        onSubmit: (values) => {
            submitDetailsone(values);
        }
    })
    
    useEffect(() => {
        const interval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }

            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(interval);
                } else {
                    setSeconds(59);
                    setMinutes(minutes - 1);
                }
            }
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [seconds]);

    const resendOTP = () => {
        setMinutes(3);
        setSeconds(0);
    };

    function Otp() {
        if (formIk.values.aadhaar !== "" ) {

              if (!aadhaarRegex.test(formIk.values.aadhaar)) {
             Sweetalert('Please enter a valid 12-digit Aadhaar number (starting with 2–9)', 'warning');
            return false;
            }
            // setData(true)
            setMinutes(3);
            setSeconds(0);
            return true;
        }
        else { Sweetalert('Please Check Whether you have entered All Fields or not', 'warning') }
        return false;
    }
const [txnNo, setTxnNo] = useState("");
const [ekycData, setEkycData] = useState(null);
const [showSubmitButton, setShowSubmitButton] = useState(true);


    const submitDetails  = async () => {
const payload ={
    aadharNo:formIk.values.aadhaar,
}
        try {
            let url = config.url.BOC_URL + public_url + "generateOtp";
            const res = await CommomLoginAunthenticatePost(url,payload);
            if (res?.data?.ResponseCode === "01") {
                Sweetalert(res?.data?.message, "success")
                  setTxnNo(res?.data?.txnNo);
                    setData(true);

            }
            else {
                Sweetalert("Failed", "error").then(()=>{
                 setData(false)
                  formIk.setFieldValue("aadhaar","")
                });    
            }

        } catch (e) {
            console.log("exception at catch block ===>" + e);
        }
    };

     const submitData = async (txnNo) => {
const payload ={
    aadharNo:formIk.values.aadhaar,
    otp:formIk.values.otp,
    txnNo:txnNo,
}
        try {
            let url = config.url.BOC_URL + public_url + "ekycOtp";
            const res = await CommomLoginAunthenticatePost(url,payload);
            if (res?.data?.ResponseCode === "01") {
                Sweetalert(res?.data?.ResponseDesc, "success")
                const parsedResponse = JSON.parse(res?.data?.response);
            setEkycData(parsedResponse);
             formIk.setFieldValue("applicantName", parsedResponse.name);
    formIk.setFieldValue("fatherName", parsedResponse.co);
    formIk.setFieldValue("dob", parsedResponse.dob);
    formIk.setFieldValue("gender", parsedResponse.gender);
    formIk.setFieldValue("distName", parsedResponse.dist);
    formIk.setFieldValue("villageName", parsedResponse.vtc);
    formIk.setFieldValue("mandalName", parsedResponse.loc);
    formIk.setFieldValue("state", parsedResponse.state);
    formIk.setFieldValue("houseNo", parsedResponse.house);
    formIk.setFieldValue("pincode", parsedResponse.pc);
    formIk.setFieldValue("address", parsedResponse.vtc);
    
             setShowSubmitButton(false);
            }
            else {
                Sweetalert("Failed", "error")
            }

        } catch (e) {
            console.log("exception at catch block ===>" + e);
        }
    };
const [day, month, year] = formIk.values.dob.split("-");
const formattedDob = `${year}-${month}-${day}`;
    let navigate = useNavigate()
    const submitDetailsone = async () => {
        const payload = {
    ...formIk.values, 
    dob: formattedDob, 
};

        try {
            let url = config.url.BOC_URL + public_url + "usrdtls";
            const res = await CommomLoginAunthenticatePost(url, payload);
            if (res?.data?.scode === "01") {
                Sweetalert("Registered Successfully", "success")
                navigate("/login")
            }
            else if (res?.data?.scode === "02") {
                Sweetalert(res?.data?.sdesc, "warning")
            }
            else if (res?.data?.scode === "03") {
    Sweetalert(res?.data?.sdesc, "warning").then(() => {
        window.location.reload();
    });
} 
            else {
                Sweetalert(res?.data?.sdesc, "warning")
            }

        } catch (e) {
            console.log("exception at catch block ===>" + e);
        }
    };
    return (
        <>
            <PublicHeader />
            <div className="main_section">  </div>
            <FormikProvider value={formIk}>
                <jnb.Form onSubmit={formIk.handleSubmit} onChange={formIk.handleChange}>
                    <jnb.Container>
                        <div className='text-center mx-5'>
                            <jnb.Row className="px-3 pb-3">
                                <jnb.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}></jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8} >
                                    <div className="inner-herbpage-service-title-sub">
                                        <h1 style={{ fontSize: '30px' }}> Registration Form</h1>
                                    </div>
                                </jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}></jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}></jnb.Col>
                                <jnb.Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8} className="jumbotron mt20 form-card-jnb pb-2 bg-white" style={{ marginTop: "5px" }}>
                                    <jnb.Row className="px-2 pt-3">
                                        <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                                        <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                            <jnb.InputGroup>
                                                <span className="mb-5 mb-md-2 field-mandatory px-2"><b>Aadhaar No</b></span>
                                                <Field type="text" name="aadhaar" className="form-control w-100 nb-1" maxLength="12"
                                                    onKeyPress={(e) => handleKeyPressNumeric(e)} />
                                                <ErrorMessage name="aadhaar" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
 <jnb.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mt-4 ' style={{ paddingRight: "5rem" }}>
                                        <button type="button" className="btn btn-primary" onClick={async() => { 
                                            const isValid = Otp(); 
                                            if (isValid) {
                                              await submitDetails(); 
                                            }
                                        }}>Send OTP</button>
                                        </jnb.Col>
                                    </jnb.Row>
                                     <br></br>
                                    {showData === true && (
                                        <>
                                            <jnb.Row className='mb-3'>
                                                <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                                                <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                                    <jnb.InputGroup>
                                                        <span className="mb-5 mb-md-2 field-mandatory px-2"><b>OTP</b></span>
                                                        <Field type="text" name="otp" className="form-control w-100 nb-1 px-2" placeholder="Enter OTP Here" onKeyPress={(e) => { allowNumbersOnly(e) }} />
                                                        <ErrorMessage name="otp" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col>
                                                {showSubmitButton && (
                                                 <jnb.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mt-2' style={{ paddingRight: "6rem" }} >
                                                    <div className='d-flex flex-row justify-content-end mt-3'>
                                                        <jnb.Button type="button" className="btn btn-success" onClick={() => submitData(txnNo)} >Submit</jnb.Button>
                                                    </div>
                                                </jnb.Col>
                                                )}
                                            </jnb.Row>
                                            <jnb.Row className='mb-3'>
                                                <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                                                <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5}>
                                                    <div className='d-flex flex-row justify-content-start'>
                                                        {seconds > 0 || minutes > 0 ? (
                                                            <p>
                                                                Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                                                                {seconds < 10 ? `0${seconds}` : seconds}
                                                            </p>
                                                        )
                                                            : (
                                                                <p>Didn't recieve code?</p>
                                                            )
                                                        }
                                                    </div>
                                                </jnb.Col>
                                                <jnb.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                                                    <div className='d-flex flex-row justify-content-end px-2'>
                                                        <button
                                                            disabled={seconds > 0 || minutes > 0}
                                                            style={{
                                                                color: seconds > 0 || minutes > 0 ? "#DFE3E8" : "#FF5630"
                                                            }}
                                                            onClick={resendOTP}
                                                        >
                                                            Resend OTP
                                                        </button>
                                                    </div>
                                                </jnb.Col>
                                            </jnb.Row>
                                            
{ekycData && (
    <>
    <jnb.Row className="px-2 pt-3">
        <jnb.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
            <jnb.InputGroup>
                <span className="mb-2 field-mandatory px-2">
                    <b>Name Of The Applicant</b>
                </span>
                <Field
                    type="text"
                   name="applicantName"
                    className="form-control w-100 mb-1"
                    readOnly
                />
            </jnb.InputGroup>
        </jnb.Col>

      <jnb.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
            <jnb.InputGroup>
                <span className="mb-2 field-mandatory px-2">
                    <b>Father Name</b>
                </span>
                <Field
                    type="text"
                   name="fatherName"
                    className="form-control w-100 mb-1"
                    readOnly
                />
            </jnb.InputGroup>
        </jnb.Col>
        <jnb.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
            <jnb.InputGroup>
                <span className="mb-2 field-mandatory px-2">
                    <b>Date of Birth</b>
                </span>
                <Field
                    type="text"
                   name="dob"
                    className="form-control w-100 mb-1"
                    readOnly
                />
            </jnb.InputGroup>
        </jnb.Col>
        <jnb.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mt-3'>
            <jnb.InputGroup>
                <span className="mb-2 field-mandatory px-2">
                    <b>Gender</b>
                </span>
                <Field
                    type="text"
                    name="gender"
                    className="form-control w-100 mb-1"
                    readOnly
                />
            </jnb.InputGroup>
        </jnb.Col>
        <jnb.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mt-3'>
            <jnb.InputGroup>
                <span className="mb-2 field-mandatory px-2">
                    <b>District</b>
                </span>
                <Field
                    type="text"
                    name="distName"
                    className="form-control w-100 mb-1"
                    readOnly
                />
            </jnb.InputGroup>
        </jnb.Col>
       <jnb.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mt-3'>
            <jnb.InputGroup>
                <span className="mb-2 field-mandatory px-2">
                    <b>Village</b>
                </span>
                <Field
                    type="text"
                    name="villageName"
                    className="form-control w-100 mb-1"
                    readOnly
                />
            </jnb.InputGroup>
        </jnb.Col>
       <jnb.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mt-3'>
            <jnb.InputGroup>
                <span className="mb-2 field-mandatory px-2">
                    <b>Mandal</b>
                </span>
                <Field
                    type="text"
                    name="mandalName"
                    className="form-control w-100 mb-1"
                    readOnly
                />
            </jnb.InputGroup>
        </jnb.Col>
        <jnb.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mt-3'>
            <jnb.InputGroup>
                <span className="mb-2 field-mandatory px-2">
                    <b>State</b>
                </span>
                <Field
                    type="text"
                 name="state"
                    className="form-control w-100 mb-1"
                    readOnly
                />
            </jnb.InputGroup>
        </jnb.Col>
         <jnb.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}className='mt-3'>
            <jnb.InputGroup>
                <span className="mb-2 field-mandatory px-2">
                    <b>House No</b>
                </span>
                <Field
                    type="text"
                name="houseNo"
                    className="form-control w-100 mb-1"
                    readOnly
                />
            </jnb.InputGroup>
        </jnb.Col>
         <jnb.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mt-3'>
            <jnb.InputGroup>
                <span className="mb-2 field-mandatory px-2">
                    <b>Pincode</b>
                </span>
                <Field
                    type="text"
                name="pincode"
                    className="form-control w-100 mb-1"
                    readOnly
                />
            </jnb.InputGroup>
        </jnb.Col>
        <jnb.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mt-3'>
            <jnb.InputGroup>
                <span className="mb-2 field-mandatory px-2">
                    <b>Address</b>
                </span>
                <Field
                    type="text"
                  name="address"
                    className="form-control w-100 mb-1"
                    readOnly
                />
            </jnb.InputGroup>
        </jnb.Col> 
    </jnb.Row>
   
<jnb.Row className="px-2 pt-3">
    <jnb.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                            <jnb.InputGroup>
                                                <span className="mb-5 mb-md-2 field-mandatory px-2"><b>Mobile No</b></span>
                                                <Field type="text" name="phoneno" className="form-control w-100 nb-1" maxLength="10" placeholder="Enter Mobile No"
                                                    onKeyPress={(e) => handleKeyPressNumeric(e)} />
                                                <ErrorMessage name="phoneno" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                         <jnb.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                            <jnb.InputGroup>
                                                <span className="mb-5 mb-md-2 field-mandatory px-2"><b>Are You a?</b></span>
                                                <Field as="select" name="citizen" className="form-control w-100 nb-1" maxLength="12">
                                                    <option value='0'>----Select----</option>
                                                    <option value='citizen-7'>CITIZEN</option>
                                                     <option value='builder-6'>BUILDER</option>
                                                
                                                </Field>
                                                <ErrorMessage name="citizen" component="div" className="text-error" />
                                            </jnb.InputGroup>
                                        </jnb.Col>
                                                <jnb.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                    <jnb.InputGroup>
                                                        <span className="mb-5 mb-md-2 field-mandatory px-2"><b>Password</b></span>
                                                        <Field type="password" name="pwd" className="form-control w-100 nb-1" maxLength="12" placeholder="Enter Password" />
                                                        <ErrorMessage name="pwd" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col>
                                                <jnb.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mt-3'>
                                                    <jnb.InputGroup>
                                                        <span className="mb-5 mb-md-2 field-mandatory px-2"><b>Confirm Password</b></span>
                                                        <Field type="password" name="repwd" className="form-control w-100 nb-1" maxLength="12" placeholder="Confirm Password" />
                                                        <ErrorMessage name="repwd" component="div" className="text-error" />
                                                    </jnb.InputGroup>
                                                </jnb.Col>
                                                </jnb.Row>
                                                 <jnb.Row className='mb-3'>
                                                {/* <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                                                <jnb.Col xs={12} sm={12} md={12} lg={5} xl={5} xxl={5} className="text-left mt-4">
                                                    <a className="text-black forgot mb-4 " href='/login'>Click here to login</a>
                                                </jnb.Col> */}
                                                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                                    <div className='d-flex flex-row justify-content-end mt-3'>
                                                        <jnb.Button type="submit" className="btn btn-success" >Click To Register</jnb.Button>
                                                    </div>

                                                </jnb.Col>
                                            </jnb.Row> 
                                                 </>
)}

                                           
                                        </>
                                    )}
                                </jnb.Col>

                            </jnb.Row>

                        </div>
                    </jnb.Container>
                </jnb.Form>
            </FormikProvider >
        </>
    )
}
